export default "__VITE_ASSET__DIhxd01g__"